module.exports = __webpack_public_path__ + "img/shiba-loading.180d1526.png";